import { useEffect } from 'react';
import { useIndexedDB } from 'react-indexed-db-hook';

import { useOnlineStatusDetector } from './useOnlineStatusDetector';

export const precacheModule = async (courseId, moduleId) => {
  const moduleUrl = `/courses/${courseId}/${moduleId}`;
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'CACHE_MODULE_ROUTE',
      url: moduleUrl,
    });
  }
};

export const useOfflineModulesRoutesPrecaching = () => {
  const { isOnline } = useOnlineStatusDetector();
  const { getAll } = useIndexedDB('modules');

  useEffect(() => {
    const init = async () => {
      const allModules = await getAll();
      allModules.forEach((module) => {
        precacheModule(module.course_id, module.id);
      });
    };
    if (isOnline) init();
  }, [isOnline]);
};
